import React from 'react';

import "./filter-header.scss"

const FilterHeader = ({children}) => {
    return (
        <div className="FilterHeader">
            {children}
        </div>
    );
};

export default FilterHeader;